<template>
    <div class="gofixInput gofixTextInput" v-bind:class="{gofixInputHasDesc:desc,gofixInputError : ((required && !value && blurInput) || error), gofixInputDisable:disabled,gofixInputNoLabel:!label}">
        <div class="mainInput">
            <slot name="gofixInput:text:before-input"></slot>
            <input :type="type"
                   :value="value"
                   :placeholder="placeholder"
                   :name="name"
                   :disabled="disabled"
                   :autocomplete="autocomplete"
                   :maxlength="maxlength"
                   @input="handleInput"
                   @change="handleChange"
                   v-on:keyup="handleInput"
                   v-on:keyup.enter="enterEmit"
                   v-on:blur="blurInput = true"
                   v-bind:class="{hasValue:(value || value === 0)}">
            <div :class="`label ${classLabel}`">{{label}}<span class="iconRequired" v-if="showIconRequired && required">*</span></div>
            <slot name="gofixInput:text:after-input"></slot>
        </div>
        <p class="desc" v-if="desc" v-html="desc"></p>
        <slot name="gofixInput:text:after-desc"></slot>
    </div>
</template>

<script>
    export default {
        name: "input-text",
        props: {
            desc: {
                type: String,
                required: false,
                default: () => null
            },
            required: {
                type: Boolean,
                required: false,
                default: () => false
            },
            label: {
                type: String,
                required: false,
                default: () => "Label"
            },
            classLabel: {
                type: String,
                required: false,
                default: () => ""
            },
            value: {
                default: () => null
            },
            showIconRequired: {
                type: Boolean,
                required: false,
                default: () => false
            },
            type: {
                type: String,
                required: false,
                validator: function (value) {
                    return ['text', 'email', 'password'].indexOf(value) !== -1
                },
                default: () => "text"
            },
            placeholder: {
                type: String,
                required: false,
                default: () => null
            },
            autocomplete: {
                type: String,
                required: false,
                default: () => "off"
            },
            name: {
                type: String,
                required: false,
                default: () => null
            },
            disabled: {
                type: Boolean,
                default: false
            },
            maxlength: {
                type: String,
                default: null
            },
            error: {
                type: Boolean,
                default: false
            },
        },

        data() {
            return {
                blurInput:false
            }
        },
        watch: {


        },
        created(){

        },
        methods: {
            handleInput (e) {
                this.$emit("input", e.target.value);
            },
            handleChange (e) {
                this.$emit("change", e.target.value);
            },
            enterEmit (e) {
                this.$emit("enter");
            }
        }
    }
</script>

<style scoped>

</style>
